import { Component, type ErrorInfo, type ReactNode } from 'react';

/**
 * Stops one broken component from turning the whole app into a blank page.
 */
export default class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ui] render failed', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center px-6 bg-white">
        <div className="max-w-md text-center">
          <h1 className="text-2xl font-semibold text-[#1E3A2E] mb-2">Something went wrong</h1>
          <p className="text-gray-600 mb-6">
            Sorry — reloading usually clears it. If it keeps happening, let us know what you were
            doing.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ backgroundColor: '#C9A450', color: '#1E3A2E' }}
            className="px-5 py-2 rounded-full text-sm font-semibold"
          >
            Reload the page
          </button>
        </div>
      </div>
    );
  }
}
